import 'C:\\Projects\\genkei\\zumeco\\static\\folder\\FolderButton.tsx.esbuild-plugin-windicss.css';
import { cx } from '@linaria/core';
import { Icon } from '../shared/components/Icon';
import { ToolbarButton } from '../shared/components/ToolbarButton';
import { ToolbarFileButton } from '../shared/components/ToolbarFileButton';
import { supportedDrawingExtensions } from '../shared/utils';
const buttonClassBase = 'min-h-7 !px-2 whitespace-pre font-size-13px leading-4 shadow hover:shadow-md';
const buttonClass = `${buttonClassBase} text-primary !bg-white !border-current`;
const invertedClass = `${buttonClassBase} !text-white !bg-primary !border-primary`;
export const FolderButton = ({
  type,
  icon,
  iconClass,
  text,
  disabled,
  inverted,
  onClick
}: {
  type?: 'submit';
  icon: string;
  iconClass?: string;
  text: string;
  disabled?: boolean;
  inverted?: boolean;
  onClick?: preact.MouseEventHandler<HTMLButtonElement>;
}) => <ToolbarButton type={type} className={inverted ? invertedClass : buttonClass} disabled={disabled} onClick={onClick}>
    <Icon icon={icon} size={18} className={cx('mr-1', iconClass)} />
    <span data-text={text}>{text}</span>
  </ToolbarButton>;
export const FolderFileButton = ({
  icon,
  text,
  onSelectFiles
}: {
  icon: string;
  text: string;
  onSelectFiles: (files: File[]) => unknown;
}) => <ToolbarFileButton className={buttonClass} accept={supportedDrawingExtensions} multiple onSelectFiles={onSelectFiles}>
    <Icon icon={icon} size={18} className="-ml-1 mr-1" />
    <span data-text={text}>{text}</span>
  </ToolbarFileButton>;